import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
    en: {
        translation: {
            loginTitle: "Log In",
            sendLabel: "Send",
            verifyLabel: "Verify",
            assignedLabel: "Assigned",
            resendOTPIn: "Resend OTP",
            emailLabel: "Email",
            passwordLabel: "Password",
            currentPassword: "Current Password",
            newPassword: "New Password",
            confirmPassword: "Confirm Password",
            loginButton: "Log In",
            forgotPassword: "Forgot Password?",
            forgotPasswordTitle: "Forgot Password",
            requestAccount: "Request an Account",
            accountRequestTitle: "Account Request",
            nameLabel: "Name",
            AddSpeaker:"Add Speaker",
            EditSpeaker:"Edit Speaker",
            SelectSpeaker:"Select Speaker",
            companyname:"Company Name",
            Settings:"Settings",
            siren_number:"Siren Number",
            address:"Address",
            Add:"Add",
            Edit:"Edit",
            city:"City",
            postcode:"postcode",
            firstName: "First Name",
            NewFolder:"New Folder",
            EditFolder:"Edit Folder",
            insurercode:"Insurer Code",
            lastName: "Last Name",
            requiredforLabel: "Required For",
            yourRequest: "Your Request",
            submitButton: "Submit",
            nextButton: "Next",
            previousButton: "Previous",
            dashboard: "Dashboard",
            dashboardTitle: "Dashboard Overview",
            toProcess: "To Process ({{count}})",
            fileNumber: "File Number",
            client: "Customer",
            status: "Status",
            toComplete: "To Complete",
            incomplete: "Incomplete",
            verified: "Verified",
            toVerify: "To Verify",
            statusSelectAria: "Select status",

            folders: "Folders",
            manageProfile: "Manage my profile",
            logOut: "Log out",
            addFolder: "Add a folder",
            registerAs: "Register as",
            selectRoleLabel: "Select a role",
            selectInsurer:"Select a role",
            UserManagement:"User Management",
            RoleManagement:"Role Management",
            selectInsurerLabel:"Select Insurer Label",
            brokerlabel: "Broker",
            insurerLabel: "Insurer",
            acsManagerLabel: "ACS Manager",
            requriedErrorMessage: "Please fill in this required field.",
            activeLabel: "Active",
            inActiveLabel: "In Active",
            pendingLabel: "Pending",
            inProgressLabel: "In Progress",
            createdLabel: "Created",
            underConstructionLabel: "Under Construction",
            completedLabel: "Completed",
            validatedLabel: "validated",
            toBeValidatedLabel: "To Be Validated",
            toBeCompletedLabel: "To Be Completed",
            toBeCheckedLabel: "To Be Checked",
            invalidLabel: "Invalid",
            waitingLabel: "Waiting",
            confirmbtnLabel: "Confirm",
            confirmStatusTitle: "Confirm Status",
            confirmStatusMessage: "Are you sure you want to update the status?",
            myAccountLabel: "My Account",
            profileLabel: "Profile",
            managePassword: "Manage Password",
            statisticsLabel: "Statistics",
            documentInvalidLabel: "Document Invalid",
            documentMissingLabel: "Document Missing",
            documentTypeLabel: "Document Type",
            AddDocumentType:"Add Document Type",
            EditDocumentType:"Edit Document Type",
            preferredDocumentLabel: "Preferred Document",
            userManagementLabel: "User Management",
            addDocumentLabel: "Add Document",
            selectDocumentTypeLabel: "Select Document Type",
            filesAwaitingVerificationLabel: "Files Awaiting Verification",
            fileNameLabe: "File Name",
            speakerLabel: "Speaker",
            requriedErrorMessageLabel: "Please fill in all required fields.",
            NorecordsfoundLabel: "No records found.",
            DragyourdocumentsLabel: "Drag your documents here or",
            browsemyfilesLabel: "browse my files",
            documentsAcceptedLabel: "Documents accepted",
            saveChangesLabel: "Save Changes",
            tobetreat: "To be treated",
            lastModifiedDateLabel: "Last Modified At",
            somethingWentWrong: "Something Went Wrong",
            SpeakerManagement:"Speaker Management List",
        }
    },
    fr: {
        translation: {
            loginTitle: "Connectez-vous",
            sendLabel: "Envoyer",
            verifyLabel: "vérifier",
            assignedLabel: "Attribué",
            resendOTPIn: "Renvoyer OTP",
            emailLabel: "Identifiant",
            passwordLabel: "Mot de passe",
            currentPassword: "Mot de Passe actuel",
            newPassword: "Nouveau mot de passe",
            confirmPassword: "Confirmez le mot de passe",
            loginButton: "Se connecter",
            forgotPassword: "Mot de passe oublié ?",
            forgotPasswordTitle: "Mot de passe oublié",
            requestAccount: "Effectuer une demande de compte",
            accountRequestTitle: "Demande de compte",
            nameLabel: "Nom",
            Settings:"Paramètres",
            companyname:"Nom de l'entreprise",
            siren_number:"Numéro de sirène",
            address:"Adresse",
            Add:"Ajouter",
            Edit:"Modifier",
            city:"ville",
            postcode:"Code Postal",
            AddSpeaker:"Ajouter un intervenant",
            EditSpeaker: "Modifier un intervenant",
            SelectSpeaker:"Sélectionnez l'intervenant de la relation",
            firstName: "Prénom",
            NewFolder:"Nouveau dossier",
            EditFolder:"Modifier le dossier",
            lastName: "Dernier Nom",
            requiredforLabel: "Requis Pour",
            yourRequest: "Votre demande",
            submitButton: "Soumettre",
            nextButton: "Suivante",
            previousButton: "Précédente",
            dashboard: "Tableau de bord",
            dashboardTitle: "Vue d'ensemble du tableau de bord",
            toProcess: "À traiter ({{count}})",
            fileNumber: "N° de dossier",
            client: "Assureurs",
            status: "Statut",
            toComplete: "À compléter",
            incomplete: "Incomplet",
            verified: "Vérifié",
            toVerify: "À vérifier",
            statusSelectAria: "Sélectionner un statut",
            folders: "Dossiers",
            manageProfile: "Gérer mon profil",
            logOut: "Se déconnecter",
            addFolder: "Ajouter un dossier",
            registerAs: "Inscrivez-vous en tant que",
            selectRoleLabel: "Choisir un rôle",
            selectInsurer:"Choisir un Assureur",
            selectInsurerLabel:"Sélectionnez l'étiquette de l'assureur",
            brokerlabel: "Courtier",
            insurerLabel: "Assureur",
            acsManagerLabel: "Gestionnaire ACS",
            requriedErrorMessage: "Veuillez remplir ce champ obligatoire.",
            activeLabel: "Actif",
            inActiveLabel: "In Actif",
            pendingLabel: "En Attente",
            inProgressLabel: "En Cours",
            createdLabel: "créé",
            underConstructionLabel: "En cours de Construction",
            completedLabel: "complété",
            validatedLabel: "validé",
            toBeValidatedLabel: "A Valider",
            toBeCompletedLabel: "à compléter",
            toBeCheckedLabel: "À vérifier",
            invalidLabel: "Invalide",
            waitingLabel: "En attendant",
            confirmbtnLabel: "Confirmer",
            confirmStatusTitle: "Confirmer le statut",
            confirmStatusMessage: "Etes-vous sûr de vouloir mettre à jour le statut ?",
            myAccountLabel: "Mon Compte",
            profileLabel: "Profil",
            managePassword: "Gérer le mot de passe",
            statisticsLabel: "Statistiques",
            documentInvalidLabel: "Document Invalide",
            AddDocumentType:"Ajouter un type de document",
            EditDocumentType:"Modifier le type de document",
            insurercode:"Code assureur",
            documentMissingLabel: "Document Manquant",
            documentTypeLabel: "Type de document",
            preferredDocumentLabel: "Document Préféré",
            SpeakerManagement:"Gestion des intervenants",
            userManagementLabel: "Gestion des utilisateurs",
            RoleManagement:"Gestion des rôles",
            UserManagement:"Gestion des utilisateurs",
            addDocumentLabel: "Ajouter un Document",
            selectDocumentTypeLabel: "Choisir un type de document",
            filesAwaitingVerificationLabel: "Dossiers En attente de Vérification",
            fileNameLabe: "Nom Du fichier",
            speakerLabel: "Intervenant",
            requriedErrorMessageLabel: "Veuillez remplir tous les champs obligatoires.",
            NorecordsfoundLabel: "Aucun enregistrement trouvé.",
            DragyourdocumentsLabel: "Glissez vos documents ici ou",
            browsemyfilesLabel: "parcourir mes fichiers",
            documentsAcceptedLabel: "Documents acceptés",
            themesetting:"Paramètres du thème",
            saveChangesLabel: "Enregistrer les Modifications",
            tobetreat: "A Traiter",
            lastModifiedDateLabel: "Dernière Modification",
            somethingWentWrong: "Quelque chose s'est mal passé"
        }
    }
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: "fr",
        fallbackLng: "fr",
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;